import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../../rules';
import { WhenCondition } from '../../conditions';
import { RuleConditionData } from '../../serialization';
import { ConditionRule } from 'lib/reviews/types';
import { RulesConstants } from 'lib/constants/rules';

export const MinimumRatingConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.MinimumRating.ItemId;

export class MinimumRatingCondition<T extends RuleContext> extends WhenCondition<T> {
  minimumRating: number;
  constructor(condition: RuleConditionData) {
    super();
    this.minimumRating = condition.minimumRating as number;
  }

  execute(ruleContext: T): boolean {
    const conditions: Array<ConditionRule> =
      (ruleContext.parameters[RulesConstants.Parameters.Conditions] as Array<ConditionRule>) ?? [];
    conditions.push({
      propertyName: 'review.reviewRating',
      comparison: 'gte',
      value: this.minimumRating,
    });
    ruleContext.parameters[RulesConstants.Parameters.Conditions] = conditions;
    return ruleContext.parameters[RulesConstants.Parameters.Operator] ==
      RulesConstants.Operators.And
      ? true
      : false;
  }
}
